import { Map } from "immutable";

import getActiveEditorState from "editor/utils/getActiveEditorState";
import getSelectedBlockInfo from "editor/utils/getSelectedBlockInfo";
import getActiveBlockType from "editor/utils/getActiveBlockType";
import getActiveBlockKey from "editor/utils/getActiveBlockKey";
import { BLOCK_TYPE } from "config/constants/editor";
import { updateActiveEditor } from "editor/actions/form";
import { CustomBlockUtils } from "editor/utils/CustomBlockUtils";

export const insertCustomBlocks = (blocks, options) => {
  return (dispatch, getState) => {
    const editorState = getActiveEditorState(getState());
    dispatch(
      updateActiveEditor(
        CustomBlockUtils.insertCustomBlocks(editorState, blocks, options)
      )
    );
  };
};

export const removeCustomBlock = key => {
  return (dispatch, getState) => {
    const editorState = getActiveEditorState(getState());
    dispatch(
      updateActiveEditor(CustomBlockUtils.removeBlockByKey(editorState, key))
    );
  };
};

export const insertEmbed = proxy => {
  const embedConfig = { ...proxy };
  const dataConfig = {};
  if (embedConfig.type === "jwplayer-video") dataConfig.autoplay = false;
  embedConfig.config = dataConfig;
  return dispatch => {
    return dispatch(
      insertCustomBlocks([
        {
          type: BLOCK_TYPE.EMBED,
          data: Map(embedConfig),
        },
      ])
    );
  };
};

export const insertImage = data => {
  return dispatch => {
    return dispatch(
      insertCustomBlocks([
        {
          type: BLOCK_TYPE.IMAGE,
          data: Map(data),
        },
      ])
    );
  };
};

export const insertKeepReading = () => {
  return dispatch => {
    return dispatch(
      insertCustomBlocks(
        [
          {
            type: BLOCK_TYPE.KEEP_READING,
            data: Map({
              buttonText: "Go deeper",
              showWordCount: true,
            }),
          },
        ],
        {
          selectionIndex: "after",
        }
      )
    );
  };
};

export const toggleQuoteWithAttribution = () => {
  return (dispatch, getState) => {
    let editorState = getActiveEditorState(getState());
    const activeBlockType = getActiveBlockType(editorState);
    if (
      activeBlockType === BLOCK_TYPE.PLAIN_QUOTE ||
      activeBlockType === BLOCK_TYPE.QUOTE_ATTRIBUTION
    ) {
      const contentState = editorState.getCurrentContent();
      const activeBlockKey = getActiveBlockKey(editorState);
      const quoteBlockKey =
        activeBlockType === BLOCK_TYPE.QUOTE_ATTRIBUTION
          ? contentState.getKeyBefore(activeBlockKey)
          : activeBlockKey;
      dispatch(removeQuote(quoteBlockKey));
    } else {
      //get the full text of all selected blocks and transform them into quote fragments
      const blockInfo = getSelectedBlockInfo(editorState);
      const fragments = blockInfo.reduce((array, block) => {
        const nextBlocks = [
          {
            text: block.text,
            characterList: block.characterList,
            type: BLOCK_TYPE.PLAIN_QUOTE,
          },
          {
            type: BLOCK_TYPE.QUOTE_ATTRIBUTION,
          },
        ];
        return [...array, ...nextBlocks];
      }, []);

      const selectionState = editorState.getSelection();
      dispatch(
        insertCustomBlocks(fragments, {
          selectionIndex: fragments.length - 2,
          safetyBlock: false,
          forceNoSplit: true,
          removeFullBlocks: {
            startKey: selectionState.getStartKey(),
            endKey: selectionState.getEndKey(),
          },
        })
      );
    }
  };
};

export const removeQuote = (quoteKey, newBlockType = BLOCK_TYPE.UNSTYLED) => {
  return (dispatch, getState) => {
    const editorState = getActiveEditorState(getState());
    const contentState = editorState.getCurrentContent();
    const quoteBlock = contentState.getBlockForKey(quoteKey);
    const quoteText = quoteBlock.getText();
    const characterList = quoteBlock.getCharacterList();
    const newFragment = [
      {
        text: quoteText,
        type: newBlockType,
        characterList,
      },
    ];
    //if the next block is an attribution, remove it. otherwise only remove quote block
    const nextBlock = contentState.getBlockAfter(quoteKey);
    const attributionKey =
      nextBlock &&
      nextBlock.getType() === BLOCK_TYPE.QUOTE_ATTRIBUTION &&
      nextBlock.getKey();
    dispatch(
      insertCustomBlocks(newFragment, {
        forceNoSplit: true,
        removeFullBlocks: {
          startKey: quoteKey,
          endKey: attributionKey || quoteKey,
        },
      })
    );
  };
};
